<template>
  <div class="block">
    <el-form class="form-map-main">
      <!--<el-form-item label="patente">-->
      <el-form-item>
        <el-input v-model="data.patent"
                  placeholder="ingrese una patente"/>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'BaseSearchVehicle',
  data() {
    return {
      data: {
        patent: '',
      },
    };
  },
  watch: {
    'data.patent': function sendInput() {
      this.$emit('sendPatent', this.data.patent);
    },
  },
};
</script>

<style scoped>

</style>
